import { Link } from "react-router-dom";
import { Wordmark, useScrollTo } from "./Navbar";
import { SITE } from "@/config/site";

export const Footer = () => {
  const scrollTo = useScrollTo();
  const links = [
    { label: "Home", id: "home" },
    { label: "Solutions", id: "solutions" },
    { label: "How It Works", id: "how-it-works" },
    { label: "About", id: "about" },
    { label: "Contact", id: "contact" },
  ];
  return (
    <footer className="bg-[#0C0E0D] border-t border-[#2A2D2A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <Wordmark light />
          <p className="mt-4 text-[13px] text-zinc-500">{SITE.tagline}</p>
          <p className="mt-2 text-[13px] text-zinc-500">{SITE.location}</p>
        </div>
        <div>
          <p className="text-[11px] font-semibold tracking-[0.24em] uppercase text-zinc-500 mb-4">Navigate</p>
          <ul className="space-y-2.5">
            {links.map((l) => (
              <li key={l.id}>
                <button onClick={() => scrollTo(l.id)} className="text-sm text-zinc-400 hover:text-sage-light transition-colors" data-testid={`footer-link-${l.id}`}>
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-[11px] font-semibold tracking-[0.24em] uppercase text-zinc-500 mb-4">Legal</p>
          <ul className="space-y-2.5">
            <li><Link to="/privacy-policy" className="text-sm text-zinc-400 hover:text-sage-light transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-use" className="text-sm text-zinc-400 hover:text-sage-light transition-colors" data-testid="footer-link-terms">Terms of Use</Link></li>
            <li><Link to="/admin/login" className="text-sm text-zinc-500 hover:text-sage-light transition-colors" data-testid="footer-link-admin">Admin Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#1E201E]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-[12px] text-zinc-600">© 2026 Westline Technologies. All rights reserved.</p>
          {SITE.abn && <p className="text-[12px] text-zinc-600" data-testid="footer-abn">ABN: {SITE.abn}</p>}
        </div>
      </div>
    </footer>
  );
};
